angular.module('env.data.services.signup', [])

    .run(function (signupService) {

    })

    .provider('signupService', function (EventingMixin) {
        var _this = this;

        this.$get = function ($log, $q, $timeout, $localStorage, $http) {

            /**
             * Get valid addresses suggestions based on the partially typed address
             * @param addressLine - Address line
             * @param city - city
             * @param state - State
             * @returns {HttpPromise} Future object
             */
            _this.getSuggestedAddresses = function (address, city, state) {

                //Form line from the address parts according to Australian rules and ask for the suggestions for that address
                //OrderManager uses appropriate branded version of the address validation API for the Footlink to validate Australian addresses
                address = address != null ? address.trim() : '';
                city = city != null ? city.trim() : '';
                state = state != null ? state.trim() : '';

                var addressLine = address + (city.length > 0 ? ", " + city : "");

                return $http
                    .get(om.config.build.baseUrl + "/footlink/address-validation/suggested?query=" + addressLine + (state.length > 0 ? "&stateTerritory=" + state : ""))
                    .then(
                        function (resp) {
                            return resp.data ? resp.data : [];
                        },
                        function (error) {
                            $log.error('Can not request email confirmation code. Error: ' + error);
                            return $q.reject(error);
                        });
            };

            /**
             * Requests confirmation code to be sent to the supplied user contacts
             * @param email - User email to request confirmation code for. The generated code will be sent to this email.
             * @param firstName - User's first name to use in email
             * @param lastName - User's last name to use in email
             * @returns {HttpPromise} Future object
             */
            _this.requestEmailConfirmationCode = function (email, firstName, lastName) {

                var model = { email: email, firstName: firstName, lastName: lastName };


                return $http
                    .post(om.config.build.baseUrl + "/signup/request-code", model)
                    .then(
                        function (resp) {
                            return resp.data ? resp.data : [];
                        },
                        function (error) {
                            $log.error('Can not request email confirmation code. Error: ' + error);
                            return $q.reject(error);
                        });
            };

            /**
             * Validate user field/value to see if we can create such a user
             * @param fieldToCheck - User object field name to validate.
             * @param valueToCheck - User object value to validate.
             * @returns {HttpPromise} Future object
             */
            _this.validateUserFieldValue = function (valueToCheck, fieldToCheck) {

                var model = { valueToCheck: valueToCheck, fieldToCheck: fieldToCheck };

                return $http
                    .post(om.config.build.baseUrl + "/signup/validate-user", model)
                    .then(
                        function (resp) {
                            return resp.status === 200;
                        },
                        function (error) {
                            $log.error('Error during user field/value validation.');
                            return false;
                        });
            };

            /**
             * Validate customer field/value to see if we can create such a customer
             * @param fieldToCheck - User object field name to validate.
             * @param valueToCheck - User object value to validate.
             * @returns {HttpPromise} Future object
             */
            _this.validateCustomerFieldValue = function (valueToCheck, fieldToCheck) {

                var model = { valueToCheck: valueToCheck, fieldToCheck: fieldToCheck };
                
                return $http
                    .post(om.config.build.baseUrl + "/signup/validate-customer", model)
                    .then(
                        function (resp) {
                            return resp.status === 200;
                        },
                        function (error) {
                            $log.error('Error during customer field/value validation.');
                            return false;
                        });
            };

            /**
             * Submits registration information about the user, its standard fields and custom fields to the server
             * @param contactConfirmationCode - Confirmation code from the email that we sent to user to confirm his contact
             * @param customerCode - Code to assign as Customer.Code
             * @param userDto - User entity DTO.
             * @param addressDto - Address entity DTO.
             * @param userCustomFields - Array of the User entity custom field objects containing type information {type: '', fieldCode: '', value: ''}
             * @param customerCustomFields - Array of the Customer entity custom field objects containing type information {type: '', fieldCode: '', value: ''}
             *
             * @returns {HttpPromise} Future object
             */
            _this.submitUserRegistrationInfo = function (contactConfirmationCode, customerCode, userDto, addressDto, userCustomFields, customerCustomFields) {

                var model = {
                    contactConfirmationCode: contactConfirmationCode, 
                    customerCode: customerCode, 
                    user: userDto,
                    address: addressDto,
                    userCustomFields: userCustomFields,
                    customerCustomFields: customerCustomFields
                };

                return $http
                    .post(om.config.build.baseUrl + "/signup/create-user", model)
                    .then(
                        function (resp) {
                            return resp.data ? resp.data : [];
                        },
                        function (error) {
                            $log.error('User registration submission failed. Error: ' + error);
                            return $q.reject(error);
                        });
            };

            /**
             * Requests support requests for a user passing to the server Customer code, phone and email.
             * May be used in various scenarios, like existing user alert or anything else.
             * @param email - User email to request support for.
             * @param customerCode - User's Customer entity Code to request support for.
             * @param phone - User's phone to request support for
             * @returns {HttpPromise} Future object
             */
            _this.submitSupportRequest = function (customerCode, email, phone) {

                var model = { customerCode: customerCode, email: email, phone: phone };


                return $http
                    .post(om.config.build.baseUrl + "/signup/support-request", model)
                    .then(
                        function (resp) {
                            return resp.data ? resp.data : [];
                        },
                        function (error) {
                            $log.error('Can not submit support request. Error: ' + error);
                            return $q.reject(error);
                        });
            };

            return _this;
        };


    })

;
